import compact from "lodash/compact";

export interface UserFullNameParts {
    firstName?: string | null;
    lastName?: string | null;
    patronymic?: string | null;
}

export const lastNameWithInitials = ({
    firstName,
    lastName,
    patronymic,
}: UserFullNameParts = {}) => {
    const firstChar = (item?: string | null) => {
        const trimmed = item?.trim();
        return trimmed ? `${trimmed.charAt(0)}.` : "";
    };
    const trimmedLastName = lastName?.trim() || "";
    return `${trimmedLastName} ${firstChar(firstName)}${firstChar(patronymic)}`.trim();
};

export const fullName = (user?: UserFullNameParts | null) => {
    if (!user) {
        return "";
    }
    const { firstName, lastName, patronymic } = user;
    return compact([lastName?.trim(), firstName?.trim(), patronymic?.trim()]).join(" ");
};
